import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as offerService from "@/services/offer.service";
import { notifyError, notifySuccess } from "@/lib/notification";

export const offerKeys = {
  all: ["offers"] as const,
  lists: () => [...offerKeys.all, "list"] as const,
  detail: (id: string) => [...offerKeys.all, "detail", id] as const,
};

export const useOffersQuery = () =>
  useQuery({
    queryKey: offerKeys.lists(),
    queryFn: offerService.fetchOffers,
  });

export const useOfferByIdQuery = (id: string) =>
  useQuery({
    queryKey: offerKeys.detail(id),
    queryFn: () => offerService.getOfferById(id),
    enabled: !!id,
  });

export const useAcceptOfferMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (offerId: string) => offerService.acceptOffer(offerId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: offerKeys.all });
      notifySuccess("Offer accepted successfully!");
    },
    onError: (error: any) => {
      notifyError(error?.response?.data?.message || "Failed to accept offer");
    },
  });
};

export const useDeclineOfferMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (offerId: string) => offerService.declineOffer(offerId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: offerKeys.all });
      notifySuccess("Offer declined successfully.");
    },
    onError: (error: any) => {
      notifyError(error?.response?.data?.message || "Failed to decline offer");
    },
  });
};
